import { graphql } from "gatsby"

import RichText from "@components/rich-text/renderer"
import mapPageComponents from "@utils/mapPageComponents"
import { useActiveEnv } from "@hooks/use-active-env"

import * as styles from "./thank-you.css"

import "../../../fragments/Page"

/**
 * The RichText references an entry with a Button content model,
 * but that only supports a single link. This will swap the
 * manage.fastly.com link with the staging link when required.
 */
const useStagingNorthstarLink = (rtContent, activeEnv) => {
  if (activeEnv !== "production" && rtContent.references.length) {
    const buttonRef = rtContent.references.find((ref) => ref.contentful_id === "28TbasU5X5LdteKT14AESm")
    if (buttonRef) {
      return {
        ...rtContent,
        references: rtContent.references.map((ref) => {
          if (ref.url === "https://manage.fastly.com") {
            return {
              ...ref,
              url: "https://manage.secretcdn-stg.net",
            }
          }
          return ref
        }),
      }
    }
  }
  return rtContent
}

const ThankYou = ({ data: { page } }) => {
  const { formConfirmation } = mapPageComponents(page.content)
  const rtContent = useStagingNorthstarLink(formConfirmation.rtContent, useActiveEnv())

  return (
    <main id="sign-up-thank-you" className={styles.page}>
      <section className={styles.card}>
        <div className={styles.content}>
          <RichText body={rtContent} mikan={formConfirmation.mikan} />
        </div>
      </section>
    </main>
  )
}

export const query = graphql`
  query ($contentful_id: String!) {
    page: contentfulPage(contentful_id: { eq: $contentful_id }) {
      ...Page
    }
  }
`

export default ThankYou

export { Head } from "@components/Head/Head"
